export function wpcf7Validation(debug = false) {
  const containers = document.querySelectorAll('.wpcf7');

  containers.forEach(container => {
    createValidator(container);
  });

  function createValidator(container) {
    const form = container.querySelector('.wpcf7-form');
    const submit = container.querySelector('.wpcf7-submit');
    if (! form || ! submit) {
      if (debug) console.log('wpcf7Validation: form');
      return;
    }
    const inputs = container.querySelectorAll('input[type="file"],input[type="text"],input[type="email"],input[type="number"],textarea');
    const acceptance = container.querySelector('.wpcf7-acceptance input[type="checkbox"]');
    let debounceTimer = -1;
  
    form.addEventListener('input', (event) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(
        function() {
          validateForm(inputs, acceptance, submit);
        },
        1000
      );
    });
  }
  function validateForm(inputs, acceptance, submit) {
    for (let input of inputs) {
      console.log(input.type);
      if ( input.ariaRequired && (input.value === null || input.value === '' || ! input.checkValidity()) ) {
        if (debug) console.log('validForm: At least one field is invalid');
        submit.classList.add('disabled');
        return;
      }
      if (input.type === 'text' && input.classList.contains('email-phone')) {
        if (! validateEmail(input.value) && ! validatePhone(input.value)) {
          if (debug) console.log('validForm: Email/phone field is invalid');
          submit.classList.add('disabled');
          return;
        }
        if (debug) console.log('validForm: Email/phone field is valid');
      }
    }
    if (acceptance && ! acceptance.checked) {
      if (debug) console.log('validForm: Acceptance is not checked');
      submit.classList.add('disabled');
      return;
    }
    if (debug) console.log('validForm: All fields are valid');
    submit.classList.remove('disabled');
  }
  function validateEmail(email) {
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email);
  }
  function validatePhone(phone) {
    let regex = /^(\d|\+){9,15}$/;
    return regex.test(phone);
  }
}

export function wpcf7FileDrop(debug = false) {
  const inputs = document.querySelectorAll('.wpcf7 input[type="file"]');
  const drops = document.querySelectorAll('.js-file-drop');

  inputs.forEach(input => {
    let matchingDrop;
    drops.forEach(drop => {
      if (input.name === drop.dataset.name) {
        matchingDrop = drop;
      }
    });
    if (matchingDrop) {
      createPair(input, matchingDrop);
    }
    else {
      createStandalone(input);
    }
  });

  function createStandalone(input) {
    const label = input.parentElement.parentElement.querySelector('.wpcf7-custom-file-tooltip');
    const labelDefault = (label) ? label.innerText : '';

    input.addEventListener('dragover', event => {
      event.preventDefault();
    });
    input.addEventListener('drop', event => {
      event.preventDefault();
      if (event.dataTransfer.files) {
        input.files = event.dataTransfer.files;

        input.classList.add('file-selected');
        if (label) {
          label.innerText = (input.files[0]) ? input.files[0].name : labelDefault;
        }
      }
    });
    input.addEventListener('change', event => {
      if (input.files[0]) {
        input.classList.add('file-selected');

        if (label) {
          label.innerText = input.files[0].name;
        }
      }
      else {
        input.classList.remove('file-selected');

        if (label) {
          label.innerText = labelDefault;
        }
      }
    });
  }
  function createPair(input, drop) {
    const label = drop.querySelector('label');
    const labelDefault = (label) ? label.innerText : '';
    
    drop.addEventListener('click', event => {
      event.preventDefault();
      input.click();
    });
    drop.addEventListener('dragover', event => {
      event.preventDefault();
    });
    drop.addEventListener('drop', event => {
      event.preventDefault();
      if (event.dataTransfer.files) {
        input.files = event.dataTransfer.files;

        drop.classList.add('file-selected');
        if (label) {
          label.innerText = (input.files[0]) ? input.files[0].name : labelDefault;
        }
      }
    });
    input.addEventListener('change', event => {
      if (input.files[0]) {
        drop.classList.add('file-selected');

        if (label) {
          label.innerText = input.files[0].name;
        }
      }
      else {
        drop.classList.remove('file-selected');

        if (label) {
          label.innerText = labelDefault;
        }
      }
    });
  }
}